export default function(value: string): boolean {
    if (value.length !== 34) {
        return false;
    }

    return /^T[1-9A-HJ-NP-Za-km-z]{33}$/.test(value);
}
